export const GET_SITES = 'GET_SITES';
export const SITES_LOAD = 'SITES_LOAD';
export const GET_SITES_ERROR = 'GET_SITES_ERROR';



// WEBPACK FOOTER //
// ./src/state/sites/types.js